import { Modes } from '@constants/canvas/layers';
import { NodeDTO, NodeDTOTypes } from '@store/services/nodes/types';

export type DeletableNode = Pick<
  NodeDTO,
  'id' | 'name' | 'type' | 'parent_asset'
>;

// Cyber Resilience borrows Capabilities and Functions from the Controls model, so there they are
// detached rather than deleted. A Remediation Action is deletable, but only on the asset model it
// originated from.
export const DELETE_DISALLOWED_TYPES_IN_RISK_MANAGEMENT: NodeDTOTypes[] = [
  NodeDTOTypes.Capabilities,
  NodeDTOTypes.Functions,
];

export const ASSET_SCOPED_DELETE_TYPES: NodeDTOTypes[] = [
  NodeDTOTypes.Initiatives,
];

export function isDeleteEligible(
  node: DeletableNode,
  mode: Modes,
  currentAssetId?: string | null,
): boolean {
  if (mode !== Modes.RiskManagement) return true;
  if (DELETE_DISALLOWED_TYPES_IN_RISK_MANAGEMENT.includes(node.type))
    return false;

  if (ASSET_SCOPED_DELETE_TYPES.includes(node.type)) {
    return Boolean(currentAssetId) && node.parent_asset === currentAssetId;
  }

  return true;
}

export function splitDeletableNodes(
  nodes: DeletableNode[],
  mode: Modes,
  currentAssetId?: string | null,
): { deletable: DeletableNode[]; ineligible: DeletableNode[] } {
  const deletable: DeletableNode[] = [];
  const ineligible: DeletableNode[] = [];

  nodes.forEach((node) => {
    if (isDeleteEligible(node, mode, currentAssetId)) {
      deletable.push(node);
    } else {
      ineligible.push(node);
    }
  });

  return { deletable, ineligible };
}
